import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "container d-flex flex-col justify-center text-center" }
const _hoisted_2 = { class: "p-3 flex justify-center items-center gap-3 w-full max-w-3xl shadow-md rounded-2xl" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  class: "flex flex-col p-3 rounded-lg",
  role: "list",
  "aria-live": "polite",
  "aria-label": "To-do list items"
}
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["aria-labelledby"]
const _hoisted_7 = ["id", "aria-label"]
const _hoisted_8 = ["id", "aria-label"]
const _hoisted_9 = ["onClick", "aria-expanded"]
const _hoisted_10 = {
  key: 1,
  class: "absolute flex flex-col right-0 text-base bg-green-800 p-3 rounded-3xl rounded-tr-none gap-3"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick", "aria-labelledby"]
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "rounded-full overflow-hidden ml-2 flex justify-center items-center" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = ["onClick"]

import TodoDatalistInput from "@/components/todocomponents/TodoDatalistInput.vue";
import TodoNavbarSettings from "@/components/todocomponents/TodoNavbarSettings.vue";
import { useGlobalStore } from "@/stores/GlobalStore";
import { useToDoStore } from "@/stores/ToDoStore";
import { addZeroString, formatDateForDisplay } from "@/utils/utils";
import { computed, nextTick, ref, toRefs, watch } from "vue";

// State variables

export default /*@__PURE__*/_defineComponent({
  __name: 'ToDoView',
  setup(__props) {

const toDoStore = useToDoStore();
const { todoText, datalist } = toRefs(toDoStore);
toDoStore.getTodosFromStorage();
const openedOptionsId = ref<number | null>(1735367445891);

// Add a new todo
const addTodo = () => {
  if (isInputEmpty.value) return;

  toDoStore.addTodo(todoText.value.trim());
};

// input Datalist

const isInputEmpty = computed(() => todoText.value.trim() === "");

// Computed properties
const openedOptionsButtonStyle = computed(() => {
  if (openedOptionsId.value === null) return "";
  return "bg-green-800 rounded-bl-none rounded-br-none";
});
const completedToDoClass = computed(() => " line-through  text-gray-500");
const textColor = computed(() => {
  return globalStore.theme === "dark" ? "text-white" : "text-black";
});
const bgDateColor = computed(() => {
  return { backgroundColor: globalStore.theme === "dark" ? "#204533" : "#ccefdb" };
});

// Open options menu
const openOptions = (id: number) => {
  if (openedOptionsId.value === id) {
    openedOptionsId.value = null;
    return;
  }
  openedOptionsId.value = id;
};

// Delete a todo with confirmation
const deleteOnConfirm = (todoId: number) => {
  const confirmed = confirm("Are you sure you want to delete this todo?");
  if (confirmed) {
    toDoStore.removeTodo(todoId);
  }
};

// Editing functionality
const editingTextAreaRef = ref<Record<number, HTMLTextAreaElement>>({});
const editingTodoId = ref<number | null>(null);
const editingTextArea = ref("");
const currentActiveTodoText = ref("");
const editToDoText = (todoId: number, todoText: string) => {
  const editFunctionality = () => {
    editingTodoId.value = todoId;
    editingTextArea.value = todoText;
    openedOptionsId.value = null;
    currentActiveTodoText.value = todoText;
    nextTick(() => {
      if (editingTextAreaRef.value) {
        editingTextAreaRef.value[0].focus();
      }
    });
  };
  if (editingTodoId.value === null) {
    editFunctionality();
  } else {
    if (currentActiveTodoText.value === editingTextArea.value) {
      editFunctionality();
    } else {
      const confirmed = confirm("The editing value will not be save! Are you sure you want to continue? ");
      if (confirmed) {
        editFunctionality();
      }
    }
  }
};

// Reset editing state
const resetEditing = () => {
  editingTodoId.value = null;
  editingTextArea.value = "";
  openedOptionsId.value = null;
  currentActiveTodoText.value = "";
};

// Cancel editing
const cancelEditing = () => {
  resetEditing();
};

// Save the updated todo text
const saveTheUpdatedToDoText = () => {
  if (!editingTodoId.value) return;
  toDoStore.updateSingleTodo(editingTodoId.value, (todo) => {
    todo.text = editingTextArea.value;
    return todo;
  });
  resetEditing();
};

// Global store
const globalStore = useGlobalStore();

watch(editingTextArea, (newValue) => {
  // console.log(newValue);
  // console.log(editingTextAreaRef);
  // test
});
// watch(computedDataList, async () => {
//   await nextTick();
//   console.log(datalistOptionsRef.value);
// });

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col justify-center items-center sticky z-2 top-20 pb-3 rounded-lg sm:px-4", _unref(globalStore).bgThemeClass])
    }, [
      _createVNode(TodoNavbarSettings),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TodoDatalistInput, {
          datalist: _unref(datalist),
          onAddTodo: addTodo
        }, null, 8, ["datalist"]),
        _createElementVNode("button", {
          onClick: addTodo,
          class: "bg-green-600 sm:px-4 px-3 py-2 rounded text-white font-bold disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-400 disabled:text-gray-800 transition-all",
          disabled: isInputEmpty.value,
          "aria-label": "Add this task"
        }, " Add ", 8, _hoisted_3)
      ])
    ], 2),
    _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toDoStore).groupedTodos, (groupedToDo, date) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: date }, [
          _createElementVNode("h4", {
            class: "mx-auto /bg-color /bg-green-500 /bg-opacity-20 px-2 py-1 rounded-lg",
            "aria-label": `Tasks for ${_unref(formatDateForDisplay)(date)}`
          }, _toDisplayString(_unref(formatDateForDisplay)(date)), 9, _hoisted_5),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedToDo, (todo) => {
            return (_openBlock(), _createElementBlock("li", {
              key: todo.id,
              class: "flex items-start gap-3 py-3 pl-3 pr-0 rounded-lg mb-3",
              "aria-labelledby": todo.id + 'listItemText',
              role: "listitem"
            }, [
              (todo.id === editingTodoId.value)
                ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                    key: 0,
                    name: "toDo text",
                    id: todo.id + 'listItemText',
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editingTextArea).value = $event)),
                    class: "w-full sm:px-4 px-3 py-2 rounded bg-inherit text-inherit custom-shadow",
                    ref_for: true,
                    ref_key: "editingTextAreaRef",
                    ref: editingTextAreaRef,
                    onKeydown: _withKeys(saveTheUpdatedToDoText, ["enter"]),
                    "aria-label": editingTextArea.value
                  }, null, 40, _hoisted_7)), [
                    [_vModelText, editingTextArea.value]
                  ])
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    id: todo.id + 'listItemText',
                    class: _normalizeClass(todo.completed && completedToDoClass.value),
                    "aria-label": todo.completed ? 'Completed: ' + todo.text : todo.text
                  }, _toDisplayString(todo.text), 11, _hoisted_8)),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["ms-auto text-2xl relative text-white", openedOptionsId.value === todo.id ? 'z-1' : 'z-0'])
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (openOptions(todo.id)),
                  class: _normalizeClass(["cursor-pointer px-3 py-1 bg-green-600 rounded-full transition-all duration-700", openedOptionsId.value === todo.id && openedOptionsButtonStyle.value]),
                  "aria-expanded": openedOptionsId.value === todo.id,
                  "aria-label": "Open options menu for this to-do",
                  title: "Open options menu for this to-do"
                }, " ⋮ ", 10, _hoisted_9),
                (todo.createdDate)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["absolute text-sm mt-2", textColor.value])
                    }, _toDisplayString(_unref(addZeroString)(todo.createdDate.getHours()) + ":" + _unref(addZeroString)(todo.createdDate.getMinutes())), 3))
                  : _createCommentVNode("", true),
                (openedOptionsId.value === todo.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (todo.id === editingTodoId.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("button", { onClick: saveTheUpdatedToDoText }, _cache[1] || (_cache[1] = [
                              _createElementVNode("span", { class: "active:text-vue-color" }, "Save", -1)
                            ])),
                            _createElementVNode("button", { onClick: cancelEditing }, _cache[2] || (_cache[2] = [
                              _createElementVNode("span", { class: "active:text-vue-color" }, "Cancel", -1)
                            ]))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (editToDoText(todo.id, todo.text))
                            }, _cache[3] || (_cache[3] = [
                              _createElementVNode("span", { class: "active:text-vue-color" }, "Edit", -1)
                            ]), 8, _hoisted_11),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_unref(toDoStore).toggleTodoComplete(todo.id)),
                              class: "flex items-center cursor-pointer",
                              "aria-labelledby": todo.id + 'span'
                            }, [
                              _createElementVNode("span", {
                                id: todo.id + 'span',
                                class: "active:text-vue-color"
                              }, "Complete", 8, _hoisted_13),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("input", {
                                  tabindex: "-1",
                                  type: "checkbox",
                                  class: "text-green-600 h-6 w-6 focus:ring-green-500 border-gray-300",
                                  checked: todo.completed,
                                  "aria-label": "Mark as complete"
                                }, null, 8, _hoisted_15)
                              ])
                            ], 8, _hoisted_12),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (deleteOnConfirm(todo.id))
                            }, _cache[4] || (_cache[4] = [
                              _createElementVNode("span", { class: "active:text-vue-color" }, "Delete", -1)
                            ]), 8, _hoisted_16)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ], 2)), [
                [_directive_auto_animate, { duration: 300 }]
              ])
            ], 8, _hoisted_6))
          }), 128))
        ], 64))
      }), 128))
    ])), [
      [_directive_auto_animate]
    ])
  ]))
}
}

})